import React from 'react';
import { string, func, array, bool, node } from 'prop-types';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from "material-ui/styles/getMuiTheme";

import cx from 'classnames';
import s from '../FormElement.css';

import portalTheme from "../../../themes/portalTheme";

const PortalRadioButtonGroup = ({
  className, description, disabled, errorText, id,
  label, name, onChange, options, required, value, onBlur,
}) => {
  const radioButtons = options.map((option, index) => (
    <RadioButton
      key={`${id}__${index}`}
      className={s.groupItem}
      disabled={disabled}
      id={`${id}__${index}`}
      title={option}
      label={option}
      value={option}
      onBlur={onBlur}
    />
  ));

  return (
    <div className={cx(s.component, className, {[`${s.disabled}`]: disabled, [`${s.error}`]: errorText})}>

      {label &&
        <label htmlFor={id} className={s.label}>{label}</label>
      }

      <MuiThemeProvider muiTheme={getMuiTheme(portalTheme)}>
        <RadioButtonGroup
          disabled={disabled}
          errorText={errorText}
          errorStyle={{color:'#B2120B'}}
          id={id}
          title={name}
          name={name}
          onChange={onChange}
          valueSelected={value}
        >
          {radioButtons}
        </RadioButtonGroup>
      </MuiThemeProvider>
      {errorText &&
        <label className={s.errorText}>{errorText}</label>
      }

      {description &&
        <label className={s.description}>{description}</label>
      }

    </div>
  );
};

PortalRadioButtonGroup.propTypes = {
  className: string,
  description: string,
  disabled: bool,
  errorText: node,
  id: string.isRequired,
  label: node,
  name: string,
  onChange: func,
  options: array.isRequired,
  required: bool,
  value: node,
  onBlur: func,
};

export default PortalRadioButtonGroup;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalRadioButtonGroup/PortalRadioButtonGroup.js